const Vue = require("vue").default
const BootstrapVue = require("bootstrap-vue").default
const manual = require("../../views/interface/manual.vue").default

Vue.use(BootstrapVue)

Vue.config.devtools = false

function drawVueManualModal({helpUrl, windowID}) {
  if (helpUrl) {
    window.manualVueInstance = new Vue({
      el: `#manual-${windowID}`,
      render: h =>
        h(manual, {
          props: {
            manualURL: `${helpUrl}`,
            translations: session.translations,
          },
        }),
    })
  }
}

module.exports = {drawVueManualModal}
